module.exports = __webpack_public_path__ + "img/ich-will-dich-nicht-vergessen.2b5f0ab2.jpg";